module.exports = __webpack_public_path__ + "static/fonts/HurmeGeometricSans2-Regular.2f2c5707.woff2";